/**
 * Stat Strip Block - Intersection Observer for border animation and column management
 */

(function () {
	// Wait for DOM to be ready
	document.addEventListener('DOMContentLoaded', function () {
		// Handle column counts for each stat strip
		const statStrips = document.querySelectorAll('.block-stat-strip');

		statStrips.forEach(function (strip) {
			const statsInStrip = strip.querySelectorAll('.block-stat');
			const statCount = statsInStrip.length;

			statsInStrip.forEach(function (stat) {
				stat.classList.add('stat-count-' + statCount);
			});
		});

		// Select all stat blocks for animation
		const statBlocks = document.querySelectorAll(
			'.block-stat-strip .block-stat'
		);

		if (statBlocks.length === 0) return;

		// Create Intersection Observer
		const observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 0.3, // Trigger when 30% of the block is visible
		};

		const observer = new IntersectionObserver(function (entries) {
			entries.forEach(function (entry) {
				if (entry.isIntersecting) {
					// Add the in-view class to trigger animation
					entry.target.classList.add('in-view');

					// Stop observing this element once animated
					observer.unobserve(entry.target);
				}
			});
		}, observerOptions);

		// Observe each stat block
		statBlocks.forEach(function (block) {
			observer.observe(block);
		});
	});
})();
